import { gql } from "apollo-boost";

export const GET_LOYALTY_PROGRAM = gql`
  query LoyaltyPrograms {
  loyaltyPrograms {
    total
    data {
      money
      point
      status
      orderGroup {
        code
      }
      shop {
        name
      }
      pointRate
      userConfirm {
        name
        lastname
        phone
        gender
      }
    }
  }
}
`